import request from './request'

/**
 * 获取价格清单
 * @param {string} name 会员类型
 */
export function getPayPrice(data) {
  return request.get('/getPayPrice.php', {
    params: data
  })
}
